import * as React from "react";
import {
  TrackerPolicy,
  TrackerPolicyContentStatusOptions,
  TrackerPolicyContentTypeOptions
} from "@models/tracker-policy";
import {Table, Button, Divider, Avatar, Tooltip} from "antd";
import {FormattedMessage, intlShape} from "react-intl";
import {PaginationDefaultParams} from "@components/custom/Paginator";
import {Icon} from 'antd';
import {SubscriptionStatusOptions} from "@models/subscription";
import {PaymentGatewayOptions} from "@models/paymentGateway";
import {getFormattedPrice} from "@utils";
import __i18n from "../../../../../intl/__i18n";
import {Link} from "react-router-dom";

type Props = {
  data: TrackerPolicy[];
  loading: boolean;
  deleteFn: (item: TrackerPolicy) => void;
  intl: intlShape.isRequired;
  currentPage: number;
};

const UserContentWatchTable: React.FC<Props> = props => {
  const {data, loading, currentPage} = props;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;
  
  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`}/>,
      width: 30,
      dataIndex: "id",
      key: "id",
      align: "right",
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: __i18n("Content Title"),
      dataIndex: "content_title",
      key: "content_title",
      align: "right",
      render: (content_title, record) => <Link to={`/video-contents/${record.video_content_id}/report`}>{content_title}</Link>
    },
    {
      title: __i18n("Total View Second"),
      dataIndex: "total_view_second",
      key: "total_view_second",
      align: "left",
    },
  ];
  
  return (
    <Table
      columns={columns}
      loading={loading}
      pagination={false}
      dataSource={data}
      rowKey="id"
    />
  );
};

export default UserContentWatchTable;
